import React from 'react'
import * as types from 'common/types'
import { mlitRiverCityRegion } from 'common/config'

import CloudIcon from '@mui/icons-material/Cloud'
import FloodIcon from '@mui/icons-material/Flood'
import InfoIcon from '@mui/icons-material/Info'
import StormIcon from '@mui/icons-material/Storm'
import WaterIcon from '@mui/icons-material/Water'
import LandslideIcon from '@mui/icons-material/Landslide'
import SsidChartIcon from '@mui/icons-material/SsidChart'
import MapIcon from '@mui/icons-material/Map'
import OpacityIcon from '@mui/icons-material/Opacity'
import TerrainIcon from '@mui/icons-material/Terrain'

import allstopPng from 'assets/road/allstop.png'
import chainPng from 'assets/road/chain.png'
import lanedecreasePng from 'assets/road/lanedecrease.png'
import nightPng from 'assets/road/night.png'
import onesidePng from 'assets/road/oneside.png'
import onestopPng from 'assets/road/onestop.png'
import otherPng from 'assets/road/other.png'
import rgkaijoPng from 'assets/road/rgkaijo.png'
import timestopPng from 'assets/road/timestop.png'
import truckPng from 'assets/road/truck.png'
import h6_15Png from 'assets/h6-15.png'
import h6_20Png from 'assets/h6-20.png'
import { isMobileOnly } from 'react-device-detect'

export const URLs = {
  jmaTyphoon: 'https://www.jma.go.jp/bosai/map.html#5/34.5/137/&elem=root&typhoon=all&contents=typhoon',
  mlitRiverPortal: `https://www.river.go.jp/portal/?region=${mlitRiverCityRegion}&contents=multi`
}

export const manualURL = 'https://data.tomoegawa-system.jp/docs/manual.pdf'

export const StageForecastHours = 6

export const isPrivateMode = process.env.REACT_APP_MODE === 'private'
export const isPublicMode = !isPrivateMode

export const MapStyles: types.MapStyle[] = [
  {
    id: 'streets',
    name: '標準地図',
    url: 'https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png'
  },
  {
    id: 'satellite',
    name: '写真地図',
    url: 'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg'
  },
  {
    id: 'light',
    name: '白地図',
    url: 'https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png'
  }
]

export const MenuItems: { id: string | types.MenuType, name: string, icon: React.ReactNode, visible: boolean, url?: string }[] = [
  {
    id: 'rain',
    name: '予測降雨',
    icon: <CloudIcon />,
    visible: true
  },
  {
    id: 'river-floods',
    name: '河川氾濫リスク',
    icon: <WaterIcon />,
    visible: true
  },
  {
    id: 'riskline',
    name: '河川リスクライン',
    icon: <SsidChartIcon />,
    visible: isPrivateMode
  },
  {
    id: 'river-floods-link-h6-15',
    name: '巴川予測システム\n(1.5倍予測)',
    icon: <img src={h6_15Png} alt='h6_15' height={22} width={22} />,
    visible: isPrivateMode,
    url: window.location.origin + (isMobileOnly ? '/mobile/?rate=1.5' : '?rate=1.5')
  },
  {
    id: 'river-floods-link-h6-20',
    name: '巴川予測システム\n(2.0倍予測)',
    icon: <img src={h6_20Png} alt='h6_20' height={22} width={22} />,
    visible: isPrivateMode,
    url: window.location.origin + (isMobileOnly ? '/mobile/?rate=2.0' : '?rate=2.0')
  },
  {
    id: 'dosya',
    name: '土砂キキクル',
    icon: <LandslideIcon />,
    visible: isPrivateMode
  },
  {
    id: 'kouzui',
    name: '洪水キキクル',
    icon: <FloodIcon />,
    visible: isPrivateMode
  },
  {
    id: 'estimated-flooding',
    name: '浸水推定システム',
    icon: <OpacityIcon />,
    visible: false
  },
  {
    id: 'typhoon',
    name: '台風情報',
    icon: <StormIcon />,
    visible: isPrivateMode,
    url: URLs.jmaTyphoon
  },
  {
    id: 'bosai',
    name: '川の防災情報',
    icon: <InfoIcon />,
    visible: isPrivateMode,
    url: URLs.mlitRiverPortal
  },
  {
    id: '3d',
    name: '3D地図',
    icon: <MapIcon />,
    visible: !isMobileOnly,
    url: 'https://3d.tomoegawa-system.jp'
  },
  {
    id: 'manual-calc',
    name: '事後破堤計算',
    icon: <TerrainIcon />,
    visible: !isMobileOnly,
    url: 'https://manual-calc.tomoegawa-system.jp'
  }
]

export const IDs = {
  rainfall: {
    tileLayer: 'rainfall-tile-layer',
    tileSource: 'rainfall-tile-source',
    wideLayer: 'rainfall-wide-layer',
    wideSource: 'rainfall-wide-source'
  },
  observatory: {
    stageImage: 'observatory-stage-image',
    rainImage: 'observatory-rain-image',
    cameraImage: 'observatory-camera-image',
    tideImage: 'observatory-tide-image',
    pumpImage: 'observatory-pump-image',
    suijinImage: 'observatory-suijin-image'
  },
  roadRegulation: {
    layer: 'road-regulation-layer',
    source: 'road-regulation-source'
  },
  geographic: {
    layer: 'geographic-layer',
    source: 'geographic-source'
  },
  riverFloods: {
    layer: 'river-floods-layer',
    source: 'river-floods-source'
  },
  riskline: {
    layer: 'riskline-layer',
    source: 'riskline-source'
  },
  dosya: {
    layer: 'dosya-layer',
    source: 'dosya-source'
  },
  kouzui: {
    layer: 'kouzui-layer',
    source: 'kouzui-source'
  },
  hazardMap: {
    layer: 'hazard-map-layer',
    source: 'hazard-map-source'
  },
  gsiVector: {
    layer: 'gsi-vector-layer',
    source: 'gsi-vector-source'
  },
  border: {
    city: {
      layer: 'border-city-layer',
      source: 'border-city-source'
    },
    river: {
      layer: 'border-river-layer',
      source: 'border-river-source'
    },
    tomoe: {
      layer: 'border-tomoe-layer',
      source: 'border-tomoe-source'
    },
    riverSmall: {
      layer: 'border-river-small-layer',
      source: 'border-river-small-source'
    },
    ShinsuiR6T10: {
      layer: 'border-ShinsuiR6T10-layer',
      source: 'border-ShinsuiR6T10-source'
    }
  },
  composite: {
    buildingLayer: 'composite-building-layer'
  },
  plateau: {
    layer: 'plateau-layer',
    source: 'plateau-source'
  },
  wind: {
    layer: 'wind-layer',
    source: 'wind-source'
  },
  landuse: {
    layer: 'landuse-layer',
    source: 'landuse-source'
  },
  school: {
    nameLayer: 'shizuoka-school-name',
    locationLayer: 'shizuoka-school-location',
  },
}

export const StageAlertLevel = {
  OUTBREAK: {
    key: 'outbreak',
    label: '氾濫発生水位',
    color: '#000000'
  },
  FLOOD: {
    key: 'flood',
    label: '氾濫発生水位',
    color: '#000000'
  },
  DANGEROUS: {
    key: 'dangerous',
    label: '氾濫危険水位',
    color: '#ad02ad'
  },
  EVACUATION: {
    key: 'evacuation',
    label: '避難判断水位',
    color: '#ff2800'
  },
  WARNING: {
    key: 'warning',
    label: '氾濫注意水位',
    color: '#f2e700'
  },
  STANDBY: {
    key: 'standby',
    label: '水防団待機水位',
    color: '#008000'
  },
  WARN: {
    key: 'warn',
    label: '危険水位',
    color: '#ad02ad'
  },
  START: {
    key: 'start',
    label: '観測開始水位',
    color: '#22b022'
  },
  TIDEMAX: {
    key: 'tidemax',
    label: '過去最高潮位',
    color: '#ff2800'
  },
  NORMAL: {
    key: 'normal',
    label: '平常',
    color: '#ffffff'
  },
  DEFICIT: {
    key: 'deficit',
    label: '休止・欠測等',
    color: '#aaaaaa'
  }
}

export const RainStatus = {
  VAL4: {
    key: '4',
    label: '20㎜以上',
    color: '#800080'
  },
  VAL3: {
    key: '3',
    label: '10㎜以上',
    color: '#ff0000'
  },
  VAL2: {
    key: '2',
    label: '5㎜以上',
    color: '#d88100'
  },
  VAL1: {
    key: '1',
    label: '1㎜以上',
    color: '#1e42af'
  },
  VAL0: {
    key: '0',
    label: '1㎜未満',
    color: '#ffffff'
  },
  DEFICIT: {
    key: 'deficit',
    label: '休止・欠測等',
    color: '#aaaaaa'
  }
}

export const PumpAlertLevel = {
  NORMAL: {
    key: 'normal',
    label: '平常',
    color: '#ffffff'
  },
  DEFICIT: {
    key: 'deficit',
    label: '休止・欠測等',
    color: '#aaaaaa'
  }
}

export const SuijinStatus = {
  FLOOD4: {
    key: 'flood4',
    label: '浸水検知: 45㎝',
    color: '#ba206e'
  },
  FLOOD3: {
    key: 'flood3',
    label: '浸水検知: 15㎝',
    color: '#ff3700'
  },
  FLOOD2: {
    key: 'flood2',
    label: '浸水検知: 5㎝',
    color: '#ffa021'
  },
  FLOOD1: {
    key: 'flood1',
    label: '浸水検知: 1cm',
    color: '#fbf43c'
  },
  WAITING: {
    key: 'waiting',
    label: '待機中',
    color: '#92d04f'
  },
  MAINTENANCE: {
    key: 'maintenance',
    label: 'メンテ中',
    color: '#333333'
  }
}

export const SuijinObservatoryLegend: types.Legend = {
  title: '浸水ｾﾝｻ',
  colors: Object.values(SuijinStatus)
    .map(l => {
      return { color: l.color, value: l.label }
    })
}

export const StageObservatoryLegend: types.Legend = {
  title: '水位',
  colors: Object.values(StageAlertLevel)
    .filter(l => l.key !== 'flood' && l.key !== 'tidemax' && l.key !== 'warn')
    .map(l => {
      return { color: l.color, value: l.label }
    })
}

export const RainObservatoryLegend: types.Legend = {
  title: '雨量(mm/10分)',
  colors: Object.values(RainStatus).map(level => {
    return { color: level.color, value: level.label }
  })
}

export const MenuLegends: { [key in types.MenuType]: types.Legend[] } = {
  'rain': [{
    title: 'レーダ・予測雨量\n(mm/h)',
    colors: [
      { color: '#ba206e', value: '80' },
      { color: '#ff3700', value: '50' },
      { color: '#ffa021', value: '30' },
      { color: '#fbf43c', value: '20' },
      { color: '#0041FF', value: '10' },
      { color: '#218CFF', value: '5' },
      { color: '#A0D2FF', value: '1' },
      { color: '#99FFFF', value: '0' }
    ]
  }],
  'river-floods': [
    {
      title: '現時刻の浸水範囲計算結果(m)',
      colors: [
        { color: '#1B67FF', value: '2.0〜' },
        { color: '#39BDD6', value: '1.0～2.0' },
        { color: '#72FFDB', value: '0.5～1.0' },
        { color: '#4AFC0C', value: '0.2～0.5' },
        { color: '#FFFF1B', value: '0.1～0.2' },
      ]
    }
  ],
  'riskline': [
    {
      title: 'リスクライン',
      colors: [
        { color: '#212121', value: 'この時間で越水の恐れ' },
        { color: '#F44336', value: '3時間以内に越水の恐れ' },
        { color: '#FFEB3B', value: '6時間以内に越水の恐れ' },
      ]
    }
  ],
  'dosya': [{
    title: '土砂災害警戒判定値',
    colors: [
      { color: '#10000e', value: '災害切迫【５】' },
      { color: '#a5009c', value: '危険　　【４】' },
      { color: '#ff251b', value: '警戒　　【３】' },
      { color: '#f1e539', value: '注意　　【２】' },
      { color: '#ffffff', value: '今後の情報等に留意' }
    ]
  }],
  'kouzui': [
    {
      title: '洪水警報の危険度分布',
      colors: [
        { color: '#10000e', value: '災害切迫【５】' },
        { color: '#a5009c', value: '危険　　【４】' },
        { color: '#ff251b', value: '警戒　　【３】' },
        { color: '#f1e539', value: '注意　　【２】' },
        { color: '#00fffe', value: '今後の情報等に留意' }
      ]
    },
    {
      title: '指定河川洪水予報',
      colors: [
        { color: '#10000e', value: '氾濫発生情報【５】' },
        { color: '#a5009c', value: '氾濫危険情報【４】' },
        { color: '#ff251b', value: '氾濫警戒情報【３】' },
        { color: '#f1e539', value: '氾濫注意情報【２】' },
        { color: '#00fffe', value: '発表なし' }
      ]
    }
  ],
  '': []
}

export const RoadSymbols = [
  {
    id: 'allstop',
    name: '全面通行止',
    url: allstopPng
  },
  {
    id: 'chain',
    name: 'チェーン必要',
    url: chainPng
  },
  {
    id: 'lanedecrease',
    name: '車線減少',
    url: lanedecreasePng
  },
  {
    id: 'night',
    name: '夜間通行止',
    url: nightPng
  },
  {
    id: 'oneside',
    name: '片側交互通行',
    url: onesidePng
  },
  {
    id: 'onestop',
    name: '片側通行止',
    url: onestopPng
  },
  {
    id: 'other',
    name: 'その他規制',
    url: otherPng
  },
  {
    id: 'rgkaijo',
    name: '規制解除中',
    url: rgkaijoPng
  },
  {
    id: 'timestop',
    name: '時間帯全面通行止',
    url: timestopPng
  },
  {
    id: 'truck',
    name: '大型車両通行止',
    url: truckPng
  }
]

export const Geographics: types.Geographic[] = [
  {
    id: 'evacuation_for_flood',
    label: '風水害緊急避難場所',
    sourceId: `${IDs.geographic.source}-evacuation_for_flood`,
    layerId: `${IDs.geographic.layer}-evacuation_for_flood`,
    url: 'https://d1zetlo8apprf7.cloudfront.net/static/evacuation_for_flood.geojson'
  },
  {
    id: 'special_consideration',
    label: '要配慮者施設',
    sourceId: `${IDs.geographic.source}-special_consideration`,
    layerId: `${IDs.geographic.layer}-special_consideration`,
    url: 'https://d1zetlo8apprf7.cloudfront.net/static/special_consideration.geojson'
  }
]

export const ForecastStages = [
  '5633_34', '5633_39', '5633_36', '99_22000_4_26', '5633_33', '5633_40', '5633_123', '99_22000_4_2', '5633_37', '5633_125',
  '99_22100_2_12', '99_22100_2_10', '99_22100_2_11', '99_22100_2_7', '99_22100_2_8', '99_22100_2_9', '99_22100_2_4',
  '99_22100_2_6', '99_22100_2_5', '99_22100_2_3', '99_22100_2_1'
]

export const ForecastPumps = [
  '99_22100_3_8', '99_22100_3_7', '99_22100_3_4', '99_22100_3_6', '99_22100_3_1', '99_22100_3_5'
]
